// Resolves enum NAMES → numeric codes at commit. The live GraphQL wire delivers source/event/consequence
// as enum NAMES (Lighthouse serialises the @enum int back to its name), so this mapping IS required.

import { appLog } from 'src/utils/logger';

/** Strip whitespace + underscores, lowercase ("Business Disruption" → "businessdisruption"). */
const normalize = (value: string): string => value.replace(/[\s_]/g, '').toLowerCase();

// Known typos → canonical, normalized. Avoids trailing-'s' stripping (would collide Criminal/Criminals).
const TYPO_MAP: Record<string, string> = {
  ransomeware: 'ransomware',
  businessdisruptions: 'businessdisruption',
};

/** Resolve a clean enum name to its int code; null (and warns) on a miss. */
export const enumNameToInt = (
  enumObj: Record<string, string | number>,
  name?: string | null,
): number | null => {
  if (!name) return null;

  const key = normalize(name);
  const resolvedKey = TYPO_MAP[key] ?? key;

  for (const enumKey of Object.keys(enumObj)) {
    // Skip numeric-enum reverse-mapping entries (e.g. "5" → "Criminals").
    if (!isNaN(Number(enumKey))) continue;
    if (normalize(enumKey) === resolvedKey) {
      const value = enumObj[enumKey];
      return typeof value === 'number' ? value : Number(value);
    }
  }

  appLog.warn(`enumNameToInt: no match for "${name}"`);
  return null;
};
